export default __webpack_public_path__ + "static/media/Bloodthirst Recurve.d4d05512.jpg";